module.exports = __webpack_public_path__ + "img/Training_courses_icon_1.0ab88ffa.svg";